module.exports = __webpack_public_path__ + "static/nestle-small-1b432bf0df3aeffe3eab458ffa7f91a2.png";